export default __webpack_public_path__ + "static/media/QuarterlyMarketPerspectives.4b7677f6.JPG";